<template>
  <div>
    <m-loader :show="!demoInit" size="smBox"/>
    <b-form-radio-group v-model="selectedEmailOption"
                        stacked
                        :disabled="disabled"
                        v-show="demoInit"
                        >
      <b-form-radio  key = "0" value = "noemail">
        I don't need business email addresses.
      </b-form-radio>
      <b-form-radio
                    key = "1"
                    value = "onlyemail"
      >
        I'll take only those records with a business email address.
      </b-form-radio>
      <b-form-radio
                    key = "2"
                    value = "email"
      >
        I'll take those with and without business email addresses.
      </b-form-radio>
    </b-form-radio-group>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectedEmailOption: {
        get () {
          return this.$store.state.order.EmailOption
        },
        set (val) {
          this.$store.commit('order/saveEmailOption', val)
        }
      },
      demoInit () {
        return this.$store.state.demo.isInit
      }
    }
  }
</script>

<style scoped lang="scss">
  .phone-span {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/MEmailOption.vue